import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.838 7.626c4.164-3.618 10.317-3.618 14.576.097.38.294.473.978.095 1.369-.284.39-.947.489-1.325.098a9.21 9.21 0 0 0-12.116 0c-.094.098-.378.195-.568.195-.284 0-.568-.195-.757-.39-.378-.392-.284-.977.095-1.37m17.794-3.52c.473.39.473.978.095 1.467-.379.39-.947.488-1.325.097-5.3-4.888-13.346-4.888-18.74 0-.19.098-.474.196-.664.196-.284 0-.473-.098-.757-.391-.379-.391-.284-.978.095-1.37a15.86 15.86 0 0 1 21.296 0m-14.387 6.94c2.272-1.661 5.3-1.661 7.762 0 .378.294.473.88.19 1.37-.19.293-.474.39-.758.39-.19 0-.379-.097-.568-.195-1.61-1.173-3.88-1.173-5.49 0-.473.39-1.04.196-1.325-.195-.379-.49-.284-1.076.19-1.37m3.055 2.935c.4-.391 1-.391 1.4 0 .2.195.3.489.3.684s-.1.489-.3.684-.4.294-.7.294-.5-.098-.7-.294-.3-.39-.3-.684c0-.293.1-.49.3-.684"
    }, null, -1)
  ]))]))
}
export default { render: render }